(function() {
    'use strict';
  
    angular
      .module('iqxCore')
      .config($locationProviderConfig)

  
    function $locationProviderConfig($locationProvider){
      // Latest version of angular changes urls to #! instead of # - this fixes that!
      $locationProvider.html5Mode({ enabled: true, requireBase: true }).hashPrefix('');
    }
  
})()